import { Carxteam, Ingeprop, Opesnfac, Taskgraf, Aleteleg, Aledocxx, Userturx } from "./Graphics";
import Criticid from "./Graphics/Criticid";
import Teincome from "./Graphics/Teincome";
import Invsindo from "./Graphics/Invsindo";
import Opepanel from "./Graphics/Opepanel";
import Entregau from "./Graphics/Entregau";
import Doabfact from "./Graphics/Doabfact";
import Doctrado from "./Graphics/Doctrado";


/**
 * Componente para seleccionar la grafica a pintar
 */
export function Graphsel({
  graphName,
  graphComponent,
  MODIDXXX,
  PROIDXXX,
  graphKeyName,
  filtersFieldsGraph
}) {

  const properties = {
    graphName,
    MODIDXXX,
    PROIDXXX,
    graphKeyName,
    filtersFieldsGraph,
  };

  const types = {
    Taskgraf: <Taskgraf {...properties} />,
    Carxteam: <Carxteam {...properties} />,
    Ingeprop: <Ingeprop {...properties} />,
    Aleteleg: <Aleteleg {...properties} />,
    Aledocxx: <Aledocxx {...properties} />,
    Opesnfac: <Opesnfac {...properties} />,
    Teincome: <Teincome {...properties} />,
    Userturx: <Userturx {...properties} />,
    Criticid: <Criticid {...properties} />,
    Invsindo: <Invsindo {...properties} />,
    Opepanel: <Opepanel {...properties} />,
    Entregau: <Entregau {...properties} />,
    Doabfact: <Doabfact {...properties} />,
    Doctrado: <Doctrado {...properties} />,
  };


  return <>{types[graphComponent]}</>;
}
